// extracted by mini-css-extract-plugin
module.exports = {"heroImage":"StrainPage_heroImage__6gusw","heroImageContainer":"StrainPage_heroImageContainer__aKWo_","leftHalfSpacing":"StrainPage_leftHalfSpacing__uChjS"};